import React from 'react';
import {
  Nav, NavbarContainer, NavLogo, Span,
  NavItems, NavLink, GitHubButton, ButtonContainer,
  MobileIcon, MobileMenu, MobileLink
} from './NavbarStyledComponent';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Bio } from '../../data/constants';

const NAV_LINKS = [
  { label: 'About', href: '#about', num: '01' },
  { label: 'Skills', href: '#skills', num: '02' },
  { label: 'Experience', href: '#experience', num: '03' },
  { label: 'Projects', href: '#projects', num: '04' },
  { label: 'Education', href: '#education', num: '05' },
  { label: 'Contact', href: '#contact', num: '06' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const close = () => setIsOpen(false);

  return (
    <Nav>
      <NavbarContainer>
        <NavLogo to='/'>
          <Span>Aman<span style={{ color: 'var(--primary, #22D3EE)' }}>.</span></Span>
        </NavLogo>

        <NavItems>
          {NAV_LINKS.map(({ label, href, num }) => (
            <li key={label}>
              <NavLink href={href}>
                <span className="num">{num}.</span>
                {label}
              </NavLink>
            </li>
          ))}
        </NavItems>

        <ButtonContainer>
          <GitHubButton href={Bio.github} target="_blank" rel="noopener noreferrer">
            GitHub
          </GitHubButton>
        </ButtonContainer>

        <MobileIcon onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes size={20} /> : <FaBars size={20} />}
        </MobileIcon>

        {isOpen && (
          <MobileMenu>
            {NAV_LINKS.map(({ label, href, num }) => (
              <MobileLink key={label} href={href} onClick={close}>
                <span className="num">{num}.</span>
                {label}
              </MobileLink>
            ))}
            <GitHubButton
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: 8 }}
            >
              GitHub
            </GitHubButton>
          </MobileMenu>
        )}
      </NavbarContainer>
    </Nav>
  );
};

export default Navbar;
